import { useEffect, useState } from "react";

import { buscarSettings } from "../../services/settingsEmVoo";

// Como a empresa trata a gravação de chamadas: "off", "ask" ou "always".
//
// Ausente vale "off" — gravar conversa sem ninguém ter pedido é justamente o
// que a LGPD não perdoa, então o silêncio da configuração não pode ser
// interpretado como consentimento.
//
// Cacheado por sessão, como `useMostrarNaoLidas`: a chave não muda enquanto
// ninguém mexe nas Configurações, e o botão de ligar existe em várias telas.

export const GRAVACAO_DESLIGADA = "off";
export const GRAVACAO_PERGUNTA = "ask";
export const GRAVACAO_SEMPRE = "always";

const VALIDOS = [GRAVACAO_DESLIGADA, GRAVACAO_PERGUNTA, GRAVACAO_SEMPRE];

let cache = null;
let pedido = null;

const buscar = () => {
	if (cache !== null) return Promise.resolve(cache);

	if (!pedido) {
		pedido = buscarSettings()
			.then(({ data }) => {
				const chave = (data || []).find((s) => s.key === "callRecordingMode");

				cache = VALIDOS.includes(chave?.value) ? chave.value : GRAVACAO_DESLIGADA;
				return cache;
			})
			// Falha de rede não pode ligar gravador: sem resposta, não grava.
			.catch(() => GRAVACAO_DESLIGADA);
	}

	return pedido;
};

export const avisarModoDeGravacao = (modo) => {
	cache = VALIDOS.includes(modo) ? modo : GRAVACAO_DESLIGADA;
	pedido = Promise.resolve(cache);
};

const useModoDeGravacao = () => {
	const [modo, setModo] = useState(cache === null ? GRAVACAO_DESLIGADA : cache);

	useEffect(() => {
		let vivo = true;

		buscar().then((valor) => {
			if (vivo) setModo(valor);
		});

		return () => {
			vivo = false;
		};
	}, []);

	return modo;
};

export default useModoDeGravacao;
